import { CardGroup, Row, Col } from 'react-bootstrap'
import Transaction from './transaction'

const Transactions = ({
  transactions,
  onToggleOwnership,
  onValidate,
  onAddImage,
  onRequestArticles,
  onChangeArticle,
  onClearArticles,
  availableArticles,
  disabled
}) => {
  if (transactions.length === 0) {
    return (
      <div className='d-flex flex-column align-items-center justify-content-center text-muted' style={{ minHeight: '60vh' }}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='120'
          height='120'
          fill='currentColor'
          viewBox='0 0 16 16'
          className='mb-4 opacity-50'
        >
          <path d='M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'/>
        </svg>
        <h2 className='mb-2'>En attente d'un camion...</h2>
        <p className='opacity-75'>Les transactions apparaîtront ici</p>
      </div>
    )
  }

  return (
    <>
      <Row xs={1} md={2} xl={3} className='g-4 pt-4'>
        {transactions.map(t => (
          <Col key={t.id}>
            <Transaction
              transaction={t}
              onToggleOwnership={onToggleOwnership}
              onValidate={onValidate}
              onAddImage={onAddImage}
              onRequestArticles={onRequestArticles}
              onChangeArticle={onChangeArticle}
              onClearArticles={onClearArticles}
              availableArticles={availableArticles}
              disabled={disabled}
            />
          </Col>
        ))}
      </Row>
    </>
  )
}

export default Transactions
